export const getEventPath = (evt: Event): EventTarget[] =>
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  evt.composedPath ? evt.composedPath() : walkTree(evt.target);

/*
 * Polyfill for composedPath for Edge and IE
 * TS types are wrong for Event.target and do not contain parentNode
 */
const walkTree = (target: EventTarget, path: any[] = []): EventTarget[] =>
  (target as any).parentNode
    ? walkTree((target as any).parentNode, path.concat(target))
    : path.concat([document, window]);

// Official documentation to check if we are in Cypress:
// https://docs.cypress.io/faq/questions/using-cypress-faq#Is-there-any-way-to-detect-if-my-app-is-running-under-Cypress
export const isInCypress = (): boolean => {
  try {
    // eslint-disable-next-line rulesdir/window-cypress
    return window.Cypress ? true : false;
  } catch {
    // We cannot access 'window' from a cross-origin context
    // ---  SecurityError Failed to read a named property 'Cypress' from 'Window':
    // ---  Blocked a frame with origin "https://inquiry.withpersona.com" from accessing a cross-origin frame.
    // Sentry: https://persona-identities-inc.sentry.io/issues/5397677535/?project=5579484&query=is%3Aunresolved+issue.priority%3A%5Bhigh%2C+medium%5D+SecurityError&referrer=issue-stream&statsPeriod=14d&stream_index=2
    // in this case, and for any other case where the check fails, we assume we are not in cypress
    return false;
  }
};

export const isInIframe = (): boolean => {
  return window.self !== window.top;
};
